define('gigaset_csp/components/order/repair/form',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"select2",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM,
	S2
) {
	return Component.create({
		block: null,

		form:				null,
		varienForm:			null,
		submitButton:		null,
		productSelect:		null,

		config:				null,

		$init: function() {
			this.block = BEM.block("csp-repair-order-register-form");

			this.config = this.block.data("config");

			this.form = this.block.getElements("form");
			this.submitButton = this.block.getElements("submit-button");
			this.varienForm = new VarienForm(this.form.get(0));

			this.productSelect = this.block.getElements("product");

			this.productSelect.select2({
				templateResult: $.proxy(function(option) {
					if (!option.id) { return option.text; }

					var $option = $([
						'<span>',
							option.text,
							'<span class="select2-results__option-notice">',
								' (', Translator.translate("purchased:"), " ", this.config.purchaseDates[option.id], ')',
							'</span>',
						'</span>'
					].join(""));
					return $option;
				}, this)
			});

			this.form.on("submit", $.proxy(this._onFormSubmit, this));
		},

		_onFormSubmit: function(e) {
			if (!this.varienForm.validator.validate()) {
				e.preventDefault();
				return;
			}

			this.block.addModifier("submitting");
			this.submitButton.button("loading");
		}
	});
});
